import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { API_BASE_URL } from '../api/client';
import { readAuthProviders } from '../api/endpoints';

/**
 * Sign in with a provider, for staff.
 *
 * **This never creates an account.** The API accepts a Google or Facebook identity only when an account
 * already exists for that address and already holds a back-office role; anything else is refused and
 * nothing is written. A staff account is access to every child on the platform, and creating one stays a
 * superuser action (R0142, R0148).
 *
 * The buttons come from `GET /auth/providers`, so a deployment with neither renders nothing at all.
 */
export const ProviderButtons = () => {
  const { data } = useQuery<string[]>({ queryKey: ['auth-providers'], queryFn: readAuthProviders });
  const providers = data ?? [];

  if (providers.length === 0) {
    return null;
  }

  // A full page load, not a route change: the next stop is the provider's own domain.
  const start = (provider: string): void => {
    const target = `${window.location.origin}/auth/callback`;

    window.location.assign(`${API_BASE_URL}/auth/${provider}?redirect=${encodeURIComponent(target)}`);
  };

  return (
    <>
      <Divider sx={{ my: 1 }}>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          alebo
        </Typography>
      </Divider>

      <Stack spacing={1}>
        {providers.includes('google') ? (
          <Button size="large" variant="outlined" startIcon={<GoogleIcon />} onClick={() => start('google')}>
            Pokračovať cez Google
          </Button>
        ) : null}
        {providers.includes('facebook') ? (
          <Button
            size="large"
            variant="outlined"
            startIcon={<FacebookIcon />}
            onClick={() => start('facebook')}
          >
            Pokračovať cez Facebook
          </Button>
        ) : null}
      </Stack>
    </>
  );
};
